import { AbstractApi, ApiBaseResponse } from '../../../common/api'
import { ObjectItem } from '../types/object.types'

class ObjectsApi extends AbstractApi {
  protected url = '/du'

  public async getObjects(): Promise<ApiBaseResponse<ObjectItem[]>> {
    const { data: response } = await this.get<ApiBaseResponse<ObjectItem[]>>(this.url)

    return response
  }

  public async create(object: Omit<ObjectItem, 'id' | 'type' | 'createdAt' | 'updatedAt'>): Promise<ApiBaseResponse<ObjectItem>> {
    const { data: response } = await this.post<ApiBaseResponse<ObjectItem>>(this.url, object)

    return response
  }

  public async update(object: Omit<ObjectItem, 'type' | 'createdAt' | 'updatedAt'>): Promise<ApiBaseResponse<ObjectItem>> {
    const { data: response } = await this.put<ApiBaseResponse<ObjectItem>>(this.url.concat(`/${String(object.id)}`), object)

    return response
  }

  public async deleteObject(id: number): Promise<number> {
    const { status } = await this.delete<number>(this.url.concat(`/${id}`))

    return status
  }
}

export const objectsApi = new ObjectsApi()
